import React from 'react';
import { LandingCanvas } from './LandingCanvas';

type Props = {
  /** `fixed` = one canvas for the whole page (performant). `section` = legacy per-section (avoid). */
  variant?: 'fixed' | 'section';
};

/** Hero-matched layers — mount once with variant="fixed" on the landing page root */
export function HeroBackground({ variant = 'section' }: Props) {
  const position = variant === 'fixed' ? 'fixed' : 'absolute';

  return (
    <div className={`${position} inset-0 z-0 overflow-hidden`} aria-hidden>
      <div className="absolute inset-0 bg-[#030712]" />
      <LandingCanvas />
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)',
          backgroundSize: '64px 64px',
        }}
      />
      <div className="pointer-events-none absolute left-1/2 top-1/3 h-[500px] w-[800px] -translate-x-1/2 rounded-full bg-emerald-600/10 blur-[120px]" />
    </div>
  );
}
